import style from "./style.module.scss";

export const ModalView = ({ className, children }) => {
  return (
    <div className={style["container"]}>
      <div className={[style["modal"], className].join(" ")}>{children}</div>
    </div>
  );
};
